// extracted by mini-css-extract-plugin
module.exports = {"total":"total--12dqV","total__label":"total__label--2n_oo","total__price":"total__price--208Yv"};